export default __webpack_public_path__ + "static/media/list.224ab1a9.mp4";